import { formatNumberNoSuffix } from "../../lens-stats/formatters";

export const formatNumberNoSuffixCurried = (value: number) => (): string => formatNumberNoSuffix(value);
